// Stepts for homepage
const careerSteps = [
{
    element: ".table",
    popover: {
        className: 'first-step-popover-class',
        title: '🙋<br>Začíname',
        description: '<b>Tu nájdeš aktuálne otvorené pracovné pozície.</b> Niekoľko z nich sme na ukážku pridali a o pár riadkov nižšie môžeš vidieť ich výpis.',
        position: 'bottom',
        showButtons: true,
    },

},
{
    element: "#sidebar",
    popover: {
        title: '📎<br>Šablóny pracovných pozícii a inzerátov',
        description: '<b>V nastavení môžeš vytvárať a ukladať šablóny.</b> Pri zadávaní novej pozície si potom stačí vybrať šablónu a všetky údaje sa ti samé predvyplnia.',
        position: 'right-center',
        showButtons: true,
    },

},
{
    element: ".guide-step-careers-3",
    popover: {
        className: 'image-popover',
        title: '<a href="../careersite" target="_blank" title="Více"><img src="/images/guide-careers-1.png"></a>',
        description: 'Tu sa môžeš neskôr prekliknúť a editovať celú vašu firemnú kariérnu stránku.',
        position: 'bottom',
        showButtons: true,
    },

},
{
    element: ".guide-step-careers-4",
    popover: {
        title: ' ',
        description: 'Pridať novú pracovnú pozíciu môžeš tu.',
        position: 'bottom-right',
        showButtons: true,
    },

},
{
    element: ".table",
    popover: {
        title: ' ',
        description: 'Tu vidíš <b>prehľad pracovných pozícii a inzerátov,</b> ktoré sú publikované na vašej kariérnej stránke (ak je aktívny modul "Hiring").',
        position: 'bottom',
        showButtons: true,
    },

},
{
    element: ".action-td",
    popover: {
        title: ' ',
        description: 'Ak je aktívny modul "Hiring", môžeš kliknutím tu  <b>zdieľať</b> inzerát na Facebooku, Twitteri alebo LinkedIne <b>na jeden klik</b>. <br><br>Kliknutím na ikonu <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-3"><path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path></svg> môžeš inzerát upraviť.',
        position: 'bottom',
        showButtons: true,
    },

},
{
    element: "#sidebar",
    popover: {
        className: 'first-step-popover-class',
        title: 'Prezri si aktuálnych zamestnancov',
        description: 'Objav, ako vyzerá Onboarding s funkciou timeline <br>(3 min)<br>',
        position: 'right-center',
        showButtons: true,
        showButtons: true,         // Do not show control buttons in footer
        doneBtnText: 'Áno, pokračovať ďalej',
        nextBtnText: 'Rozumiem',        // Next button text for this step
        prevBtnText: 'Späť',
    },
    onNext: () => {
        // Prevent moving to the next step
        window.location.assign("/onboarding#guide");

    }
},
]



export default careerSteps
